var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 32.4l-.4-.4h-4.9c-1.2 0-2.2-1-2.2-2.2V6.7c0-1.2 1-2.2 2.2-2.2h20c1.2 0 2.2 1 2.2 2.2v23.1c0 1.2-1 2.2-2.2 2.2h-4.9l-.4.4-2.9 2.9-2.9-2.9zm13.5-1.2h.9V6.7h-.9H10.6h-.9v23.1h.9h7.6l.8.8 2 2 2-2 .8-.8h7.6zM20.4 26v1h-.9v-1h.9zm4.2-12.2c0-2.7-2.2-4.8-4.8-4.8-1.9 0-3.5 1.2-4.2 2.9h-.8c.3-2 2.1-3.6 4.4-3.6 2.8 0 5 2.2 5 5 0 1.1-.4 1.8-1.2 2.6-.4.4-.8.7-1.2 1.1-.8.6-1.4 1.3-1.7 2.4h-.6c.1-.5.3-.9.5-1.3.4-.6 1-1.1 1.6-1.6.1 0 .2-.1.3-.2.5-.4.9-.8 1.3-1.3.6-.6 1.1-1.5 1.1-2.5z",
    stroke: "#1E2D73"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.06bc84bf419d4d183a3651d11c6dc137.svg";
export { ForwardRef as ReactComponent };